import { Grid } from "@mui/material";
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import Checkbox from "../../../framework/Checkbox";
import SelectInput from "../../../framework/SelectInput";
import Shortcut from "../../../framework/Shortcut";
import classes from "./AddProduct.module.css";
import Button from "../../../framework/Button";
import GlobalContext from "../../../framework/GlobalContext";
import TextInput from "../../../framework/TextInput";
import NumberInput from "../../../framework/NumberInput";
import {
  gstValues,
  medicineCategories,
  medicineScheduleTypes,
  therapeuticTypes,
} from "../../../utils/constant";
import { searchManufacturer } from "../../../services/manufacturer-services";
import ChipInputSelect from "../../../framework/ChipInputSelect";
import {
  getMedicineDetails,
  saveMedicine,
  searchCompounds,
  searchGlobalMedicine,
  searchItemType,
} from "../../../services/medicine-services";
import { displayToast } from "../../../framework/toast/toastUtils";
import _ from "lodash";
import { searchCategories } from "../../../services/category-services.js";
import { createFormState } from "./addProductUtils";
// import ProductsContext from "../ProductContext";

const AddProduct = ({
  isProductSearchable = true,
  editProductId,
  newProduct = null,
  onSave = () => {}, // Pashava
  onEscape = () => {},
}) => {
  const { setCurrentComponent, setShowLoading } = useContext(GlobalContext);
  const [productName, setProductName] = useState("");
  const [productNameBase, setProductNameBase] = useState("");
  const [productId, setProductId] = useState("");
  const [itemType, setItemType] = useState();
  const [category, setCategory] = useState("");
  const [categoryId, setCategoryId] = useState("");
  const [medicinePackaging, setMedicinePackaging] = useState("");
  const [therapeutic, setTherapeutic] = useState(null);
  const [subTherapeutic, setSubTherapeutic] = useState("");
  const [barcode, setBarcode] = useState("");
  const [medicineShortCode, setMedicineShortCode] = useState("");
  const [manufacturer, setManufacturer] = useState();
  const [gst, setGst] = useState("");
  const [gstPer, setGstPer] = useState("");
  const [minStock, setMinStock] = useState("");
  const [maxStock, setMaxStock] = useState(null);
  const [hsnCode, setHsnCode] = useState("");
  const [rack, setRack] = useState("");
  const [remarks, setRemarks] = useState("");
  const [isTb, setIsTb] = useState(false);
  const [isLoose, setIsLoose] = useState(false);
  const [divisor, setDivisor] = useState("");
  const [substitute, setSubstitute] = useState("");
  const [compoundOption, setCompoundOption] = useState(null);

  const [manufacturers, setManufacturers] = useState([]);
  const [compoundOptions, setCompoundOptions] = useState([]);
  const [medicineOptions, setMedicineOptions] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [medicineItemTypes, setMedicineItemTypes] = useState([]);
  const [scheduleType, setScheduleType] = useState();

  const [error, setError] = useState({});

  const editProductSaveButtonRef = useRef();

  // const escapeHandler = useCallback(() => {
  //   setShowAddProduct(false);
  // }, [setShowAddProduct]);

  const withHsnValueCap = ({ value }) => value.length <= 8;

  const manufacturerChangedHandler = (event, value) => {
    if (value?.length > 2) {
      searchManufacturer(`search=${value.trim()}`).then((response) => {
        let result = response.result.rows;
        result = result.map((manufacturerData) => {
          return {
            id: manufacturerData.manufacturerId,
            label: manufacturerData.manufacturerName,
          };
        });
        setManufacturers([...result]);
      });
    }
  };
  const compoundInputChangeHandler = useCallback((event, value) => {
    if (value?.length > 2) {
      searchCompounds(`search=${value.trim()}`).then((response) => {
        let result = response.result.rows.map((cd) => {
          return cd.generic;
        });
        setCompoundOptions(result);
      });
    }
  }, []);

  // Function to fetch and set the medicine values
  const updateSelectedProduct = useCallback(
    (productId) => {
      setShowLoading(true);
      getMedicineDetails(`medicineId=${productId}`)
        .then((response) => {
          let res = response.result;
          setProductName(res.medicineName);
          setProductNameBase(res.medicineNameBase);
          setProductId(res.medicineId);
          setItemType({ label: res.itemtype });
          setCategoryId(res.categoryId);
          setCategory(
            medicineCategories.filter((g) => g.id === res.categoryId)[0]?.label
          );
          setMedicinePackaging(res.medicinePackaging);
          setTherapeutic(
            res.therapeutic
              ? therapeuticTypes.filter((data) => {
                  return data.label === res.therapeutic;
                })[0]
              : { label: "" }
          );
          setSubTherapeutic(res.subtherapeutic || "");
          setBarcode(res.barcode || "");
          setMedicineShortCode(res.medicineShortCode || "");
          setManufacturer({
            label: res.manufacturerName ? res.manufacturerName : "",
            id: res.manufacturerId ? res.manufacturerId : "",
          });
          setGst(
            gstValues.filter((g) => g.id === res.medicineGstPer)[0]?.label || ""
          );
          setGstPer(
            gstValues.filter((g) => g.id === res.medicineGstPer)[0]?.id || ""
          );
          setMinStock(res.minStock || "");
          setMaxStock(res.maxStock || "");
          setHsnCode(res.hsnCode);
          setRack(res.rack || "");
          setRemarks(res.remarks || "");
          setIsTb(res.generic?.istb || false);
          setIsLoose(res.isLoose || false);
          setDivisor(res.divisor);
          setScheduleType(
            res.scheduledId
              ? medicineScheduleTypes.filter(
                  (scheduleType) => scheduleType.id === res.scheduledId
                )[0]
              : { id: "", label: "" }
          );
          setCompoundOption(
            res.generic.genericDosage
              ? res.generic.genericDosage.split(",").sort()
              : []
          );
          setError({});
          setShowLoading(false);
        })
        .catch((err) => console.log(err));
    },
    [setShowLoading]
  );

  // Function to set salts and generic type on substitute change
  const substituteChangeHandler = useCallback((productId) => {
    getMedicineDetails(`medicineId=${productId}`)
      .then((res) => {
        if (res.generic) {
          setScheduleType(
            medicineScheduleTypes.filter(
              (scheduleType) => scheduleType.label === res.generic?.genericType
            )[0] || { id: "", label: "" }
          );
          setCompoundOption(res.generic.genericDosage.split(",").sort()); //CHECK
        }
      })
      .catch((err) => console.log(err));
  }, []);

  const searchMedicine = useCallback((searchTerm) => {
    searchGlobalMedicine(`search=${searchTerm.replace(" ", "")}`).then(
      (response) => {
        setMedicineOptions(
          response?.result?.map((medicineData) => {
            return {
              id: medicineData.medicineId,
              label: medicineData.medicineNameDetailed,
              medicineName: medicineData.medicineName,
            };
          }) || []
        );
      }
    );
  }, []);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debounceSearchMedicine = useCallback(
    _.debounce(searchMedicine, 300, { leading: true }),
    []
  );

  const changeHandler = (e, value) => {
    setCompoundOption(value);
  };

  const setErrorState = (fieldName, message) => {
    setError((prevState) => {
      prevState[fieldName] = true;
      return { ...prevState };
    });
    displayToast({
      type: "error",
      title: message,
    });
  };

  const removeErrorState = (fieldName) => {
    setError((prevState) => {
      prevState[fieldName] = false;
      return { ...prevState };
    });
  };

  const validateField = (fieldName, value, message) => {
    if (value.length < 1) {
      setErrorState(fieldName, message);
    } else if (error[fieldName]) {
      removeErrorState(fieldName);
    }
  };

  const validateForm = () => {
    if (!productName) {
      setErrorState("productName", "Please enter a medicine name");
      return false;
    } else if (error["productName"]) {
      removeErrorState("productName");
    }

    if (!itemType) {
      setErrorState("itemType", "Please enter an item type");
      return false;
    } else if (error["itemType"]) {
      removeErrorState("itemType");
    }

    if (!category) {
      setErrorState("categoryId", "Please select a category");
      return false;
    } else if (error["categoryId"]) {
      removeErrorState("categoryId");
    }

    if (!medicinePackaging) {
      setErrorState("medicinePackaging", "Please enter a packaging");
      return false;
    } else if (error["medicinePackaging"]) {
      removeErrorState("medicinePackaging");
    }
    if (!manufacturer) {
      setErrorState("manufacturerName", "Please enter a manufacturer name");
      return false;
    } else if (error["manufacturerName"]) {
      removeErrorState("manufacturerName");
    }

    if (!gst) {
      setErrorState("medicineGstPer", "Please select a valid GST option");
      return false;
    } else if (error["medicineGstPer"]) {
      removeErrorState("medicineGstPer");
    }

    if (!scheduleType) {
      setErrorState("scheduledId", "Please select a schedule type");
      return false;
    } else if (error["scheduledId"]) {
      removeErrorState("scheduledId");
    }

    if (!hsnCode) {
      setErrorState("hsnCode", "Please enter a valid HSN code");
      return false;
    } else if (error["hsnCode"]) {
      removeErrorState("hsnCode");
    }

    if (!divisor) {
      setErrorState("divisor", "Please enter a valid Divisor");
      return false;
    } else if (error["divisor"]) {
      removeErrorState("divisor");
    }

    if (minStock || maxStock) {
      if (minStock > maxStock) {
        setErrorState(
          "addProductMaxStock",
          "Min stock cannot be greater than max stock"
        );
        return false;
      } else if (error["addProductMaxStock"]) {
        removeErrorState("addProductMaxStock");
      }
    }
    return true;
  };

  const saveFormHandler = () => {
    if (validateForm()) {
      const productNameDetailed =
        productName + " " + itemType.label + " " + medicinePackaging;
      const productNameNospace = productNameDetailed.replaceAll(/\W|_/g, "");

      const formState = createFormState({
        productNameDetailed,
        productNameNospace,
        productName,
        productId,
        itemType,
        categoryId,
        medicinePackaging,
        therapeutic,
        subTherapeutic,
        barcode,
        medicineShortCode,
        manufacturer,
        gstPer,
        minStock,
        maxStock,
        hsnCode,
        rack,
        remarks,
        isTb,
        isLoose,
        divisor,
        scheduleType,
        genericDosage: compoundOption,
      });

      saveMedicine(
        // `${formState.medicineId ? `query=${formState.medicineId}` : ""}`, // check
        formState
      )
        .then((response) => {
          if (response.status !== "success") {
            displayToast({
              type: "error",
              title: response,
            });
            return;
          }
          displayToast({
            type: "success",
            title: "Product updated successfully",
          });
          onSave(response.result);
          // setShowAddProduct(false);
        })
        .catch(() => {
          // setAddProductStatus({ isApiError: true });
        });
    }
  };

  const resetForm = () => {
    setProductName("");
    setProductNameBase("");
    setProductId("");
    setItemType("");
    setCategory("");
    setCategoryId("");
    setMedicinePackaging("");
    setTherapeutic(null);
    setSubTherapeutic("");
    setBarcode("");
    setMedicineShortCode("");
    setManufacturer();
    setGst("");
    setGstPer("");
    setMinStock("");
    setMaxStock(null);
    setHsnCode("");
    setRack("");
    setRemarks("");
    setIsTb(false);
    setIsLoose(false);
    setDivisor("");
    setCompoundOption(null);
    setManufacturers([]);
    setScheduleType();
    setError({});
  };

  const keyupListener = useCallback(
    (event) => {
      const key = event.key?.toLowerCase();
      if (event.ctrlKey && key === "s") {
        editProductSaveButtonRef.current.click();
        return;
      }
      if (key === "escape") {
        // escapeHandler();
        onEscape();
        return;
      }
    },
    [onEscape]
  );

  // For setting categories
  useEffect(() => {
    searchCategories().then((response) => {
      let updatedResponse = response.result.rows.map((categoryData) => {
        return {
          id: categoryData.categoryId,
          label: categoryData.categoryName,
        };
      });
      setCategoryOptions(updatedResponse);
    });
  }, []);

  useEffect(() => {
    searchItemType().then((response) => {
      let updatedResponse = response.result.rows.map((itemType, idx) => {
        return {
          id: idx,
          label: itemType,
        };
      });
      setMedicineItemTypes(updatedResponse);
    });
  }, []);

  useEffect(() => {
    document.addEventListener("keyup", keyupListener, false);
    return () => {
      document.removeEventListener("keyup", keyupListener, false);
    };
  }, [keyupListener]);

  useEffect(() => {
    if (editProductId) {
      updateSelectedProduct(editProductId);
    }
  }, [editProductId, updateSelectedProduct]);

  useEffect(() => {
    if (newProduct) setProductName(newProduct);
  }, [newProduct]);

  return (
    <div className={classes["add-product-container"]}>
      <div className={classes["add-product-header"]}>
        {`${productName} ${
          itemType?.label ? itemType.label : ""
        } ${medicinePackaging}`}
        <div className={classes["add-product-header-shortcuts"]}>
          <Shortcut keys={["Esc"]} label="Cancel" />
        </div>
      </div>
      <div className={classes["add-product"]}>
        <Grid
          container
          spacing={2}
          columns={6}
          sx={{
            margin: "5px 0px 5px -10px",
            width: "100%",
          }} /*QA feedback*/
        >
          <Grid item xs={2}>
            <SelectInput
              label="Product Name"
              id="add_product_name"
              onFocus={() => {
                setCurrentComponent("add_product_name");
              }}
              onChange={(e, newValue) => {
                updateSelectedProduct(newValue.id);
              }}
              getOptionLabel={(option) => option.label || option}
              isOptionEqualToValue={(option, value) => {
                return option?.label === value; //  || value === "";
              }}
              value={productName}
              freeSolo={true}
              onInputChange={(e, value) => {
                if (value?.length > 2) {
                  debounceSearchMedicine(value);
                }
                if (value?.length === 0) {
                  resetForm();
                }
              }}
              options={medicineOptions}
              onBlur={(e) => {
                setProductName(e.target.value);
                validateField(
                  "productName",
                  e.target.value,
                  "Please enter a medicine name"
                );
              }}
              markers={JSON.stringify({
                down: "add_product_sub_therapeutic",
                left: "add_product_compounds",
                right: "add_product_type",
              })}
              error={error?.productName}
              required={true}
              autoFocus
            />
          </Grid>
          <Grid item xs={1}>
            <SelectInput
              id="add_product_type"
              name="itemtype"
              label="Item-Type"
              value={itemType}
              options={medicineItemTypes}
              onFocus={() => setCurrentComponent("add_product_type")}
              onChange={(e, option) => {
                setItemType(option);
              }}
              onInputChange={(e) => {
                setItemType({
                  label: e.target.value.toUpperCase(),
                });
              }}
              onBlur={(e) => {
                validateField(
                  "itemType",
                  e.target.value,
                  "Please enter an item type"
                );
              }}
              isOptionEqualToValue={(option, value) => {
                return value === option.label || value === "";
              }}
              markers={JSON.stringify({
                down: "add_product_barcode",
                left: "add_product_name",
                right: "add_product_category",
              })}
              error={error?.itemType}
              required
              freeSolo
            />
          </Grid>
          <Grid item xs={1}>
            <SelectInput
              id="add_product_category"
              name="categoryId"
              label="Category"
              value={category}
              options={categoryOptions}
              getOptionLabel={(option) => option.label || option}
              isOptionEqualToValue={(option, value) => {
                return option.label === value || value === "";
              }}
              onFocus={() => setCurrentComponent("add_product_category")}
              onChange={(event, option) => {
                setCategory(option.label);
                setCategoryId(option.id);
              }}
              onBlur={(e) => {
                validateField(
                  "categoryId",
                  e.target.value,
                  "Please select a category"
                );
              }}
              markers={JSON.stringify({
                down: "add_product_short_code",
                left: "add_product_type",
                right: "add_product_packaging",
              })}
              error={error?.categoryId}
              required
            />
          </Grid>
          <Grid item xs={1}>
            <TextInput
              id="add_product_packaging"
              value={medicinePackaging}
              name="medicinePackaging"
              label="Packaging"
              onFocus={() => setCurrentComponent("add_product_packaging")}
              onChange={(e) => {
                setMedicinePackaging(e.target.value);
              }}
              onBlur={(e) => {
                validateField(
                  "medicinePackaging",
                  e.target.value,
                  "Please enter a packaging"
                );
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  down: "add_product_manufacturer",
                  left: "add_product_category",
                  right: "add_product_therapeutic",
                }),
              }}
              error={error.medicinePackaging}
              required
            />
          </Grid>
          <Grid item xs={1}>
            <SelectInput
              id="add_product_therapeutic"
              name="therapeutic"
              label="Therapeutic"
              value={therapeutic}
              onFocus={() => setCurrentComponent("add_product_therapeutic")}
              onChange={(event, option) => {
                setTherapeutic(option);
              }}
              onInputChange={(e) => {
                setTherapeutic({
                  label: e.target.value,
                });
              }}
              options={therapeuticTypes}
              isOptionEqualToValue={(option, value) => {
                return option.label === value || value === "";
              }}
              markers={JSON.stringify({
                down: "add_product_manufacturer",
                left: "add_product_packaging",
                right: "add_product_sub_therapeutic",
              })}
              freeSolo
            />
          </Grid>
          <Grid item xs={2}>
            <TextInput
              id="add_product_sub_therapeutic"
              value={subTherapeutic}
              name="subtherapeutic"
              label="Sub-Therapeutic"
              onFocus={() => setCurrentComponent("add_product_sub_therapeutic")}
              onChange={(e) => {
                setSubTherapeutic(e.target.value);
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "add_product_name",
                  down: "add_product_gst",
                  left: "add_product_therapeutic",
                  right: "add_product_barcode",
                }),
              }}
            />
          </Grid>
          <Grid item xs={1}>
            <TextInput
              id="add_product_barcode"
              value={barcode}
              name="barcode"
              label="Barcode"
              onFocus={() => setCurrentComponent("add_product_barcode")}
              onChange={(e) => {
                setBarcode(e.target.value);
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "add_product_type",
                  down: "add_product_min_stock",
                  left: "add_product_sub_therapeutic",
                  right: "add_product_short_code",
                }),
              }}
            />
          </Grid>
          <Grid item xs={1}>
            <TextInput
              id="add_product_short_code"
              name="medicineShortCode"
              label="Short Code"
              value={medicineShortCode}
              onFocus={() => setCurrentComponent("add_product_short_code")}
              onChange={(e) => {
                setMedicineShortCode(e.target.value);
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "add_product_category",
                  down: "add_product_max_stock",
                  left: "add_product_barcode",
                  right: "add_product_manufacturer",
                }),
              }}
            />
          </Grid>
          <Grid item xs={2}>
            <SelectInput
              id="add_product_manufacturer"
              name="manufacturerName"
              value={manufacturer}
              label="Manufacturer"
              onFocus={() => setCurrentComponent("add_product_manufacturer")}
              onBlur={(e) => {
                validateField(
                  "manufacturerName",
                  e.target.value,
                  "Please enter a manufacturer name"
                );
              }}
              onChange={(event, option) => {
                setManufacturer(option);
              }}
              options={manufacturers}
              onInputChange={(e, value) => {
                setManufacturer({ id: "", label: value });
                manufacturerChangedHandler(e, value);
              }}
              isOptionEqualToValue={(option, value) => {
                return option.id === value.id;
              }}
              markers={JSON.stringify({
                up: "add_product_packaging",
                down: "add_product_schedule_type",
                left: "add_product_short_code",
                right: "add_product_gst",
              })}
              error={error?.manufacturerName}
              required
              freeSolo
            />
          </Grid>
          <Grid item xs={1}>
            <SelectInput
              id="add_product_gst"
              name="medicineGstPer"
              value={gst}
              label="GST"
              onFocus={() => setCurrentComponent("add_product_gst")}
              isOptionEqualToValue={(option, value) => {
                return option.label === value || value === "";
              }}
              onBlur={(e) => {
                validateField(
                  "medicineGstPer",
                  e.target.value,
                  "Please select a valid GST option"
                );
              }}
              onChange={(event, option) => {
                setGst(option.label);
                setGstPer(option.id);
              }}
              getOptionLabel={(option) => {
                return option.label || option;
              }}
              options={gstValues}
              markers={JSON.stringify({
                up: "add_product_sub_therapeutic",
                down: "add_product_rack",
                left: "add_product_manufacturer",
                right: "add_product_min_stock",
              })}
              error={error?.medicineGstPer}
              required
            />
          </Grid>
          <Grid item xs={1}>
            <NumberInput
              id="add_product_min_stock"
              name="minStock"
              label="Min Stock"
              value={minStock}
              onFocus={() => setCurrentComponent("add_product_min_stock")}
              onValueChange={(values) => {
                setMinStock(values.floatValue);
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "add_product_barcode",
                  down: "add_product_remarks",
                  left: "add_product_gst",
                  right: "add_product_max_stock",
                }),
              }}
            />
          </Grid>
          <Grid item xs={1}>
            <NumberInput
              id="add_product_max_stock"
              //   ref={editProductMaxStockRef}
              name="maxStock"
              label="Max Stock"
              value={maxStock}
              onFocus={() => setCurrentComponent("add_product_max_stock")}
              onValueChange={(values) => {
                // handleFormChange("maxStock", values.floatValue);
                setMaxStock(values.floatValue);
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "add_product_short_code",
                  down: "add_product_remarks",
                  left: "add_product_min_stock",
                  right: "add_product_schedule_type",
                }),
              }}
            />
          </Grid>
          <Grid item xs={2}>
            <SelectInput
              id="add_product_schedule_type"
              name="scheduledId"
              value={scheduleType}
              label="Schedule Type"
              onFocus={() => setCurrentComponent("add_product_schedule_type")}
              onBlur={(e) => {
                validateField(
                  "scheduledId",
                  e.target.value,
                  "Please select a schedule type"
                );
              }}
              onChange={(event, option) => {
                setScheduleType(option);
              }}
              options={medicineScheduleTypes}
              isOptionEqualToValue={(option, value) =>
                option.label === value.label || option.label === ""
              }
              markers={JSON.stringify({
                up: "add_product_manufacturer",
                down: "add_product_isTB",
                left: "add_product_max_stock",
                right: "add_product_hsn_code",
              })}
              error={error?.scheduledId}
              required
            />
          </Grid>
          <Grid item xs={1}>
            <NumberInput
              id="add_product_hsn_code"
              value={hsnCode}
              name="hsnCode"
              label="HSN Code"
              onFocus={() => setCurrentComponent("add_product_hsn_code")}
              onBlur={(e) => {
                validateField(
                  "hsnCode",
                  e.target.value,
                  "Please enter a valid HSN code"
                );
              }}
              onValueChange={(values) => {
                setHsnCode(values.floatValue);
              }}
              isAllowed={withHsnValueCap}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "add_product_manufacturer",
                  // down: formState?.isLoose
                  //   ? "add_product_qty_per_unit"
                  //   : "add_product_isLoose",
                  left: "add_product_schedule_type",
                  right: "add_product_rack",
                }),
              }}
              error={error?.hsnCode}
              allowNegative={false}
              required
            />
          </Grid>
          <Grid item xs={0.5}>
            <TextInput
              id="add_product_rack"
              name="rack"
              label="Rack"
              value={rack}
              onFocus={() => setCurrentComponent("add_product_rack")}
              onChange={(e) => {
                setRack(e.target.value);
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "add_product_cgst",
                  down: "add_product_compounds",
                  left: "add_product_hsn_code",
                  right: "add_product_remarks",
                }),
              }}
            />
          </Grid>
          <Grid item xs={2}>
            <TextInput
              id="add_product_remarks"
              name="remarks"
              label="Remarks"
              value={remarks}
              onFocus={() => setCurrentComponent("add_product_remarks")}
              onChange={(e) => {
                setRemarks(e.target.value);
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "add_product_min_stock",
                  down: "add_product_compounds",
                  left: "add_product_rack",
                  right: "add_product_isTB",
                }),
              }}
            />
          </Grid>
          <Grid item xs={0.5}>
            <Checkbox
              id="add_product_isTB"
              name="istb"
              label="Is TB"
              onFocus={() => setCurrentComponent("add_product_isTB")}
              checked={isTb}
              onChange={(e) => {
                setIsTb(e.target.checked);
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "add_product_schedule_type",
                  down: "add_product_compounds",
                  left: "add_product_remarks",
                  right: "add_product_isLoose",
                }),
              }}
            />
          </Grid>
          <Grid item xs={0.5}>
            <Checkbox
              id="add_product_isLoose"
              name="isLoose"
              label="Is Loose"
              checked={isLoose}
              onFocus={() => setCurrentComponent("add_product_isLoose")}
              onChange={(e) => {
                setIsLoose(e.target.checked);
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "add_product_schedule_type",
                  down: "add_product_compounds",
                  left: "add_product_isTB",
                  right: "add_product_qty_per_unit",
                }),
              }}
            />
          </Grid>
          <Grid item xs={0.8}>
            <NumberInput
              id="add_product_qty_per_unit"
              name="divisor"
              label="Packaging Qty."
              value={divisor}
              onBlur={(e) => {
                validateField(
                  "divisor",
                  e.target.value,
                  "Please enter a valid divisor"
                );
              }}
              onFocus={() => setCurrentComponent("add_product_qty_per_unit")}
              onValueChange={(values) => {
                setDivisor(values.floatValue);
              }}
              allowNegative={false}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "add_product_hsn_code",
                  down: "add_product_compounds",
                  left: "add_product_isLoose",
                  right: "add_substitute",
                }),
              }}
              error={error?.divisor}
              required
            />
          </Grid>
          <Grid item xs={1.7}>
            <SelectInput
              label="Substitute for"
              id="add_substitute"
              onFocus={() => {
                setCurrentComponent("add_substitute");
              }}
              onChange={(e, newValue) => {
                substituteChangeHandler(newValue.id);
              }}
              getOptionLabel={(option) => option.label || option}
              isOptionEqualToValue={(option, value) => {
                return option?.label === value || value === "";
              }}
              value={substitute}
              renderOption={(props, option) => {
                return (
                  <li {...props} key={option.id}>
                    {option.label}
                  </li>
                );
              }}
              onInputChange={(e, value) => {
                if (value?.length > 2) {
                  debounceSearchMedicine(value);
                }
                if (value?.length < 1) {
                  setCompoundOption(null);
                  setScheduleType({ id: "", label: "" });
                }
              }}
              options={medicineOptions}
              onBlur={(e) => {
                setSubstitute(e.target.value);
              }}
              markers={JSON.stringify({
                down: "add_product_compounds",
                left: "add_product_qty_per_unit",
                right: "add_product_compounds",
              })}
            />
          </Grid>
          <Grid item xs={6}>
            <ChipInputSelect
              id="add_product_compounds"
              name="genericDosage"
              label="Salts(compounds)"
              value={compoundOption}
              onFocus={() => setCurrentComponent("add_product_compounds")}
              options={compoundOptions}
              getOptionLabel={(option) => {
                return option;
              }}
              onInputChange={compoundInputChangeHandler}
              onChange={changeHandler}
              multiple={true}
              disableCloseOnSelect={true}
              blurOnSelect={false}
              markers={JSON.stringify({
                up: "add_product_rack",
                down: "",
                left: "add_substitute",
                right: "add_product_name",
              })}
              freeSolo
            />
          </Grid>
        </Grid>
      </div>
      <div className={classes["add-product-button-container"]}>
        <Button
          label="Save Product"
          color="violet"
          ref={editProductSaveButtonRef}
          endIcon={<Shortcut keys={["Ctrl", "S"]} />}
          onFocus={() => setCurrentComponent("add_product_save_button")}
          onClick={saveFormHandler}
        />
      </div>
    </div>
  );
};

export default AddProduct;
